import room1 from "./images/details-1.jpeg";
import room2 from "./images/details-2.jpeg";
import room3 from "./images/details-3.jpeg";
import room4 from "./images/details-4.jpeg";
import img1 from "./images/room-1.jpeg";
import img2 from "./images/room-2.jpeg";
import img3 from "./images/room-3.jpeg";
import img4 from "./images/room-4.jpeg";
import img5 from "./images/room-5.jpeg";
import img6 from "./images/room-6.jpeg";
import img7 from "./images/room-7.jpeg";
import img8 from "./images/room-8.jpeg";
import img9 from "./images/room-9.jpeg";
import img10 from "./images/room-10.jpeg";
import img11 from "./images/room-11.jpeg";
import img12 from "./images/room-12.jpeg";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {
        sys: {
            id: "1"
        },
        fields: {
            name: "Solteiro econômico",
            slug: "single-economy",
            type: "single",
            price: 100,
            size: 200,
            capacity: 1,
            pets: false,
            breakfast: false,
            featured: false,
            description:
                "O hotel quarto familiar oferece atendimento personalizado para que os hóspedes tenham boas memórias no lugar, através de uma experiência única zelada por profissionais competentes. A equipe é responsável por cuidar de detalhes importantes para que os hóspedes não tenham nenhuma preocupação durante a estadia. Além disso, o hotel quarto familiar resulta em excelentes vantagens de custo-benefício e possibilita garantias diferenciadas das dos concorrentes.",
            extras: [
                "SERVIÇOS DE HOTEL QUARTO FAMILIAR",
                "HOTEL RECONHECIDO POR QUALIDADE",
                "TV a cabo e Wi-Fi",
                "Variedade Gastronômica",
                "Salas para Reuniões e Auditórios",
                "Internet",
                "Camas confortáveis"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: img1
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room2
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room3
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room4
                        }
                    }
                }
            ]
        }
    },
    {
        sys: {
            id: "2"
        },
        fields: {
            name: "Solteiro básico",
            slug: "single-basic",
            type: "single",
            price: 150,
            size: 250,
            capacity: 1,
            pets: false,
            breakfast: false,
            featured: false,
            description:
                "O hotel quarto familiar oferece atendimento personalizado para que os hóspedes tenham boas memórias no lugar, através de uma experiência única zelada por profissionais competentes. A equipe é responsável por cuidar de detalhes importantes para que os hóspedes não tenham nenhuma preocupação durante a estadia. Além disso, o hotel quarto familiar resulta em excelentes vantagens de custo-benefício e possibilita garantias diferenciadas das dos concorrentes.",
            extras: [
                "SERVIÇOS DE HOTEL QUARTO FAMILIAR",
                "HOTEL RECONHECIDO POR QUALIDADE",
                "TV a cabo e Wi-Fi",
                "Variedade Gastronômica",
                "Salas para Reuniões e Auditórios",
                "Internet",
                "Camas confortáveis"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: img2
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room2
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room3
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room4
                        }
                    }
                }
            ]
        }
    },
    {
        sys: {
            id: "3"
        },
        fields: {
            name: "Solteiro padrão",
            slug: "single-standard",
            type: "single",
            price: 250,
            size: 300,
            capacity: 1,
            pets: true,
            breakfast: false,
            featured: false,
            description:
                "O hotel quarto familiar oferece atendimento personalizado para que os hóspedes tenham boas memórias no lugar, através de uma experiência única zelada por profissionais competentes. A equipe é responsável por cuidar de detalhes importantes para que os hóspedes não tenham nenhuma preocupação durante a estadia. Além disso, o hotel quarto familiar resulta em excelentes vantagens de custo-benefício e possibilita garantias diferenciadas das dos concorrentes.",
            extras: [
                "SERVIÇOS DE HOTEL QUARTO FAMILIAR",
                "HOTEL RECONHECIDO POR QUALIDADE",
                "TV a cabo e Wi-Fi",
                "Variedade Gastronômica",
                "Salas para Reuniões e Auditórios",
                "Internet",
                "Camas confortáveis"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: img3
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room2
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room3
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room4
                        }
                    }
                }
            ]
        }
    },
    {
        sys: {
            id: "4"
        },
        fields: {
            name: "Solteiro Luxo",
            slug: "single-deluxe",
            type: "single",
            price: 300,
            size: 400,
            capacity: 1,
            pets: true,
            breakfast: true,
            featured: false,
            description:
                "O hotel quarto familiar oferece atendimento personalizado para que os hóspedes tenham boas memórias no lugar, através de uma experiência única zelada por profissionais competentes. A equipe é responsável por cuidar de detalhes importantes para que os hóspedes não tenham nenhuma preocupação durante a estadia. Além disso, o hotel quarto familiar resulta em excelentes vantagens de custo-benefício e possibilita garantias diferenciadas das dos concorrentes.",
            extras: [
                "SERVIÇOS DE HOTEL QUARTO FAMILIAR",
                "HOTEL RECONHECIDO POR QUALIDADE",
                "TV a cabo e Wi-Fi",
                "Variedade Gastronômica",
                "Salas para Reuniões e Auditórios",
                "Internet",
                "Camas confortáveis"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: img4
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room2
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room3
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room4
                        }
                    }
                }
            ]
        }
    },
    {
        sys: {
            id: "5"
        },
        fields: {
            name: "Duplo econômico",
            slug: "double-economy",
            type: "double",
            price: 200,
            size: 300,
            capacity: 2,
            pets: false,
            breakfast: false,
            featured: false,
            description:
                "O hotel quarto familiar oferece atendimento personalizado para que os hóspedes tenham boas memórias no lugar, através de uma experiência única zelada por profissionais competentes. A equipe é responsável por cuidar de detalhes importantes para que os hóspedes não tenham nenhuma preocupação durante a estadia. Além disso, o hotel quarto familiar resulta em excelentes vantagens de custo-benefício e possibilita garantias diferenciadas das dos concorrentes.",
            extras: [
                "SERVIÇOS DE HOTEL QUARTO FAMILIAR",
                "HOTEL RECONHECIDO POR QUALIDADE",
                "TV a cabo e Wi-Fi",
                "Variedade Gastronômica",
                "Salas para Reuniões e Auditórios",
                "Internet",
                "Camas confortáveis"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: img5
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room2
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room3
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room4
                        }
                    }
                }
            ]
        }
    },
    {
        sys: {
            id: "6"
        },
        fields: {
            name: "Duplo básico",
            slug: "double-basic",
            type: "double",
            price: 250,
            size: 350,
            capacity: 2,
            pets: false,
            breakfast: false,
            featured: false,
            description:
                "O hotel quarto familiar oferece atendimento personalizado para que os hóspedes tenham boas memórias no lugar, através de uma experiência única zelada por profissionais competentes. A equipe é responsável por cuidar de detalhes importantes para que os hóspedes não tenham nenhuma preocupação durante a estadia. Além disso, o hotel quarto familiar resulta em excelentes vantagens de custo-benefício e possibilita garantias diferenciadas das dos concorrentes.",
            extras: [
                "SERVIÇOS DE HOTEL QUARTO FAMILIAR",
                "HOTEL RECONHECIDO POR QUALIDADE",
                "TV a cabo e Wi-Fi",
                "Variedade Gastronômica",
                "Salas para Reuniões e Auditórios",
                "Internet",
                "Camas confortáveis"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: img6
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room2
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room3
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room4
                        }
                    }
                }
            ]
        }
    },
    {
        sys: {
            id: "7"
        },
        fields: {
            name: "Padrão duplo",
            slug: "double-standard",
            type: "double",
            price: 300,
            size: 400,
            capacity: 2,
            pets: true,
            breakfast: false,
            featured: false,
            description:
                "O hotel quarto familiar oferece atendimento personalizado para que os hóspedes tenham boas memórias no lugar, através de uma experiência única zelada por profissionais competentes. A equipe é responsável por cuidar de detalhes importantes para que os hóspedes não tenham nenhuma preocupação durante a estadia. Além disso, o hotel quarto familiar resulta em excelentes vantagens de custo-benefício e possibilita garantias diferenciadas das dos concorrentes.",
            extras: [
                "SERVIÇOS DE HOTEL QUARTO FAMILIAR",
                "HOTEL RECONHECIDO POR QUALIDADE",
                "TV a cabo e Wi-Fi",
                "Variedade Gastronômica",
                "Salas para Reuniões e Auditórios",
                "Internet",
                "Camas confortáveis"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: img7
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room2
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room3
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room4
                        }
                    }
                }
            ]
        }
    },
    {
        sys: {
            id: "8"
        },
        fields: {
            name: "Luxo Duplo",
            slug: "double-deluxe",
            type: "double",
            price: 400,
            size: 500,
            capacity: 2,
            pets: true,
            breakfast: true,
            featured: true,
            description:
                "O hotel quarto familiar oferece atendimento personalizado para que os hóspedes tenham boas memórias no lugar, através de uma experiência única zelada por profissionais competentes. A equipe é responsável por cuidar de detalhes importantes para que os hóspedes não tenham nenhuma preocupação durante a estadia. Além disso, o hotel quarto familiar resulta em excelentes vantagens de custo-benefício e possibilita garantias diferenciadas das dos concorrentes.",
            extras: [
                "SERVIÇOS DE HOTEL QUARTO FAMILIAR",
                "HOTEL RECONHECIDO POR QUALIDADE",
                "TV a cabo e Wi-Fi",
                "Variedade Gastronômica",
                "Salas para Reuniões e Auditórios",
                "Internet",
                "Camas confortáveis"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: img8
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room2
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room3
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room4
                        }
                    }
                }
            ]
        }
    },
    {
        sys: {
            id: "9"
        },
        fields: {
            name: "Família econômico",
            slug: "family-economy",
            type: "family",
            price: 300,
            size: 500,
            capacity: 3,
            pets: false,
            breakfast: false,
            featured: false,
            description:
                "O hotel quarto familiar oferece atendimento personalizado para que os hóspedes tenham boas memórias no lugar, através de uma experiência única zelada por profissionais competentes. A equipe é responsável por cuidar de detalhes importantes para que os hóspedes não tenham nenhuma preocupação durante a estadia. Além disso, o hotel quarto familiar resulta em excelentes vantagens de custo-benefício e possibilita garantias diferenciadas das dos concorrentes.",
            extras: [
                "SERVIÇOS DE HOTEL QUARTO FAMILIAR",
                "HOTEL RECONHECIDO POR QUALIDADE",
                "TV a cabo e Wi-Fi",
                "Variedade Gastronômica",
                "Salas para Reuniões e Auditórios",
                "Internet",
                "Camas confortáveis"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: img9
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room2
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room3
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room4
                        }
                    }
                }
            ]
        }
    },
    {
        sys: {
            id: "10"
        },
        fields: {
            name: "Família básica",
            slug: "family-basic",
            type: "family",
            price: 350,
            size: 550,
            capacity: 4,
            pets: false,
            breakfast: false,
            featured: false,
            description:
                "O hotel quarto familiar oferece atendimento personalizado para que os hóspedes tenham boas memórias no lugar, através de uma experiência única zelada por profissionais competentes. A equipe é responsável por cuidar de detalhes importantes para que os hóspedes não tenham nenhuma preocupação durante a estadia. Além disso, o hotel quarto familiar resulta em excelentes vantagens de custo-benefício e possibilita garantias diferenciadas das dos concorrentes.",
            extras: [
                "SERVIÇOS DE HOTEL QUARTO FAMILIAR",
                "HOTEL RECONHECIDO POR QUALIDADE",
                "TV a cabo e Wi-Fi",
                "Variedade Gastronômica",
                "Salas para Reuniões e Auditórios",
                "Internet",
                "Camas confortáveis"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: img10
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room2
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room3
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room4
                        }
                    }
                }
            ]
        }
    },
    {
        sys: {
            id: "11"
        },
        fields: {
            name: "Padrão familiar",
            slug: "family-standard",
            type: "family",
            price: 400,
            size: 600,
            capacity: 5,
            pets: true,
            breakfast: false,
            featured: false,
            description:
                "O hotel quarto familiar oferece atendimento personalizado para que os hóspedes tenham boas memórias no lugar, através de uma experiência única zelada por profissionais competentes. A equipe é responsável por cuidar de detalhes importantes para que os hóspedes não tenham nenhuma preocupação durante a estadia. Além disso, o hotel quarto familiar resulta em excelentes vantagens de custo-benefício e possibilita garantias diferenciadas das dos concorrentes.",
            extras: [
                "SERVIÇOS DE HOTEL QUARTO FAMILIAR",
                "HOTEL RECONHECIDO POR QUALIDADE",
                "TV a cabo e Wi-Fi",
                "Variedade Gastronômica",
                "Salas para Reuniões e Auditórios",
                "Internet",
                "Camas confortáveis"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: img11
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room2
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room3
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room4
                        }
                    }
                }
            ]
        }
    },
    {
        sys: {
            id: "12"
        },
        fields: {
            name: "família de luxo",
            slug: "family-deluxe",
            type: "family",
            price: 500,
            size: 700,
            capacity: 6,
            pets: true,
            breakfast: true,
            featured: true,
            description:
                "O hotel quarto familiar oferece atendimento personalizado para que os hóspedes tenham boas memórias no lugar, através de uma experiência única zelada por profissionais competentes. A equipe é responsável por cuidar de detalhes importantes para que os hóspedes não tenham nenhuma preocupação durante a estadia. Além disso, o hotel quarto familiar resulta em excelentes vantagens de custo-benefício e possibilita garantias diferenciadas das dos concorrentes.",
            extras: [
                "SERVIÇOS DE HOTEL QUARTO FAMILIAR",
                "HOTEL RECONHECIDO POR QUALIDADE",
                "TV a cabo e Wi-Fi",
                "Variedade Gastronômica",
                "Salas para Reuniões e Auditórios",
                "Internet",
                "Camas confortáveis"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: img12
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room2
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room3
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room4
                        }
                    }
                }
            ]
        }
    },
    {
        sys: {
            id: "13"
        },
        fields: {
            name: "Presidencial",
            slug: "presidential-room",
            type: "presidential",
            price: 600,
            size: 1000,
            capacity: 10,
            pets: true,
            breakfast: true,
            featured: true,
            description:
                "O hotel quarto Presidencial oferece atendimento personalizado para que os hóspedes tenham boas memórias no lugar, através de uma experiência única zelada por profissionais competentes. A equipe é responsável por cuidar de detalhes importantes para que os hóspedes não tenham nenhuma preocupação durante a estadia. Além disso, o hotel quarto familiar resulta em excelentes vantagens de custo-benefício e possibilita garantias diferenciadas das dos concorrentes.",
            extras: [
                "HOTEL QUARTO PRESIDENCIAL",
                "HOTEL RECONHECIDO POR QUALIDADE",
                "TV a cabo e Wi-Fi",
                "Variedade Gastronômica",
                "Salas para Reuniões e Auditórios",
                "Internet",
                "Camas confortáveis"
            ],
            images: [
                {
                    fields: {
                        file: {
                            url: room1
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room2
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room3
                        }
                    }
                },
                {
                    fields: {
                        file: {
                            url: room4
                        }
                    }
                }
            ]
        }
    }
];
